import AIHistoryChat from './src/main.vue'

AIHistoryChat.install = Vue => {
  Vue.component(AIHistoryChat.name, AIHistoryChat)
}

export default AIHistoryChat
